import {css} from '@emotion/css';
import {ratio16to9} from '../../../../styles/js/variables';

export default {
  container: css`
    label: youTube;
    position: relative;
    height: 0;
    margin: 0 auto;
    padding-bottom: ${ratio16to9};
  `,
  iframe: css`
    label: youTube_iframe;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `,
};
